module.exports = __webpack_public_path__ + "fdb3c007516edf1743390eebd9179787.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/four-menu.png
// module id = 1077
// module chunks = 0